// @ts-nocheck
import $ from 'jquery';
import DateFormat from 'dateformat';
import * as React from 'react';
import NotRunning from '../images/NotRunning.png';
import Running from '../images/Running.png';
import RSSIUNK from '../images/RSSI/RSSI_UNK.png';
import RSSI1 from '../images/RSSI/RSSI_1.png';
import RSSI2 from '../images/RSSI/RSSI_2.png';
import RSSI3 from '../images/RSSI/RSSI_3.png';
import RSSI4 from '../images/RSSI/RSSI_4.png';
import RSSI5 from '../images/RSSI/RSSI_5.png';
import GroupChat from '../images/GroupChat.png';
import UnknownStatus from '../images/Status/UnknownStatus.png';
import ErrorStatus from '../images/Status/ErrorStatus.png';
import PendingStatus from '../images/Status/PendingStatus.png';
import IssuedStatus from '../images/Status/IssuedStatus.png';
import ExpiredStatus from '../images/Status/ExpiredStatus.png';
import CancelStatus from '../images/Status/CancelStatus.png';
import SucessStatus from '../images/Status/SucessStatus.png';
import AcceptedStatus from '../images/Status/AcceptedStatus.png';
import RejectedStatus from '../images/Status/RejectedStatus.png';
import DiscardedStatus from '../images/Status/DiscardedStatus.png';
import RetryStatus from '../images/Status/RetryStatus.png';
import AcceptedByBusyRCDStatus from '../images/Status/AcceptedByBusyRCDStatus.png';
import AwaitingPrerequisites from '../images/Status/AwaitingPrerequisites.png';
import CancellationRequest from '../images/Status/CancellationRequest.png';
import SendToVC from '../images/Status/SendToVC.png';
import ValidationPendingStatus from '../images/Status/ValidationPendingStatus.png';
import UndeliverableStatus from '../images/Status/UndeliverableStatus.png';
import deletepng from '../images/delete.png';
import AssetStateActive from '../images/AssetState/ActiveRA.svg';
import AssetStateDisconnected from '../images/AssetState/DisconnectedRA.png';
import AssetStateRetired from '../images/AssetState/RetiredRA.svg';

export class GensetCellRender extends React.Component {
    constructor(props: any) {
        super(props);
    }
    static gensetSwitchFormatterImg(params) {
        if (params.data != null && params.data != undefined) {
            if (params.data.IgnitionOn != null && params.data.IgnitionOn != undefined) {
                if (params.data.IgnitionOn.toString().toUpperCase().trim() == "TRUE")
                    return <div className="power-onbg"><span className="fa fa-power-off power-icon" > </span></div>;
                //return '<div class="power-onbg"><span class="fa fa-power-off power-icon"></span></div>';
                else if (params.data.IgnitionOn.toString().toUpperCase().trim() == "FALSE")
                    return <div className="power-offbg"><span className="fa fa-power-off power-icon" > </span></div>;
                //return '<div class="power-offbg"><span class="fa fa-power-off power-icon"></span></div>';
                else
                    return '';
            }
            //return params.value;
        }

        return '';
    }
    static FuelLevelQuickFilterFormatter(params) {
        if (params != null && params != undefined && params != '') {
            if (params.value < 0) {
                switch (params.toString()) {
                    case "-7": return "No Sensor";
                    case "-6": return "Config Error";
                    case "-5": return "Fuel Reading Unavailable";
                    case "-4": return "Not Configured";
                    case "-3": return "Sensor Error";
                    case "-2": return "Sensor Error";
                    case "-1": return "Unknown";
                    default:
                        return "*No Fuel Level";
                }
            }
            else {
                var image: any = params.value;
                if (image > 17)
                    return params.value;
                else
                    image = params.value - 1;

                if (image == 0)
                    image = "E";
                else if (image == 16)
                    image = "F";

                //var element = document.createElement("span");
                //element.className = "reefer-alert";
                //var imageElement = document.createElement("img");
                //imageElement.src = "../images/FuelFractionImages/" + image + ".png";
                //element.appendChild(imageElement);
                //return element;

                return <span className="reefer-alert"><img src={"../images/FuelFractionImages/" + image + ".png"}></img></span>;
            }

        }
    }
    static fillLevelTrace(params) {
        if (params.data != null && params.data != undefined && params.data != '') {

            if (params.data.HasFuelSensor != null && params.data.HasFuelSensor != undefined
                && params.data.HasFuelSensor === false) {
                return "No Sensor";
            }
            else {
                if (params.data.HasFuelSensor != null && params.data.HasFuelSensor.toString().toUpperCase().trim() == "TRUE") {
                    if (params.data.FuelLevelQualifier != null && ((params.data.FuelLevelQualifier == 'A') || (params.data.FuelLevelQualifier == 'P'))) {
                        if (params.data.FuelLevelTierNumber != null) {
                            return <span className="reefer-alert"><img src={"../images/FuelFractionImages/" + params.data.FractionDisplayGif}></img></span>;
                        }
                        else {
                            if (params.data.FuelLevelPct != null) {
                                var tempRoundingValue = "2";
                                return parseFloat(params.data.FuelLevelPct.toFixed(parseInt(tempRoundingValue))) + " %";
                            }
                            else {
                                return <span title="Fuel Reading Unavailable">Fuel Reading Unavailable </span>;
                            }
                        }
                    }
                    else {
                        if (params.data.FuelLevelQualifier == "S")
                            return <span title="Sensor Error">Sensor Error</span>;
                        else
                            return params.data.FuelLevelQualifierDesc;
                    }
                }
                else
                    return "-NA-";
            }

        }
        else
            return '-NA-';
    }
    static RSSITypeFormatter(params) {
        var imageSrc = "";
        if (params.data != null && params.data != undefined) {//WI-21812:For Unknown RSSI Id image is not showing
            if (params.data.RSSI != null && params.data.RSSI != undefined) {
                if (params.data.RSSI == 0)
                    imageSrc = RSSIUNK;
                else if (params.data.RSSI <= -111)
                    imageSrc = RSSI1;
                else if (params.data.RSSI >= -110 && params.data.RSSI <= -100)
                    imageSrc = RSSI2;
                else if (params.data.RSSI >= -99 && params.data.RSSI <= -88)
                    imageSrc = RSSI3;
                else if (params.data.RSSI >= -87 && params.data.RSSI <= -76)
                    imageSrc = RSSI4;
                else if (params.data.RSSI >= -75)
                    imageSrc = RSSI5;
                else
                    imageSrc = RSSIUNK;
            }
            else
                imageSrc = RSSIUNK;//WI-21812:For Unknown RSSI Id image is not showing
        }
        return <span className="reefer-alert"><img src={imageSrc}></img></span>;

    }
    static EngineSortingFormatterGrouping(param) {
        if (param != null && param != undefined) {
            if (param == "0")
                return <div><span className="reefer-alert"><img src={NotRunning} title="NO"></img></span><span className='aggrid-CellSignal'> NO</span></div>;
            else if (param == "1")
                return <div><span className="reefer-alert"><img src={Running} title="YES"></img></span><span className='aggrid-CellSignal'> YES</span></div>;
            //else
            //    return "-NA-";
        }
        return "*No ENG";
    }
    static RSSIFormatterGrouping(param) {
        if (param != null && param != undefined) {
            if (param == 1)
                return <div><span className="reefer-alert"><img src={RSSI5} title="5 Bars"></img></span><span className='aggrid-CellSignal'> 5 Bars</span></div>;
            else if (param == 2)
                return <div><span className="reefer-alert"><img src={RSSI4} title="4 Bars"></img></span><span className='aggrid-CellSignal'> 4 Bars</span></div>;
            else if (param == 3)
                return <div><span className="reefer-alert"><img src={RSSI3} title="3 Bars"></img></span><span className='aggrid-CellSignal'> 3 Bars</span></div>;
            else if (param == 4)
                return <div><span className="reefer-alert"><img src={RSSI2} title="2 Bars"></img></span><span className='aggrid-CellSignal'> 2 Bars</span></div>;
            else if (param == 5)
                return <div><span className="reefer-alert"><img src={RSSI1} title="1 Bar"></img></span><span className='aggrid-CellSignal'> 1 Bar</span></div>;
            else
                return <div><span className="reefer-alert"><img src={RSSIUNK} title="Unknown"></img></span><span className='aggrid-CellSignal'> Unknown</span></div>;
        }
    }
    static FillLevelTraceGrouping(params) {
        if (params != null && params != undefined && params != '') {
            if (params < 0) {
                switch (params.toString()) {
                    case "-7": return "No Sensor";
                    case "-6": return "Config Error";
                    case "-5": return "Fuel Reading Unavailable";
                    case "-4": return "Not Configured";
                    case "-3": return "Sensor Error";
                    case "-2": return "Sensor Error";
                    case "-1": return "Unknown";
                    default:
                        return "*No Fuel Level";
                }
            }
            else {
                var image: any = params;
                if (image > 17)
                    return params;
                else
                    image = params - 1;

                if (image == 0)
                    image = "E";
                else if (image == 16)
                    image = "F";

                //var element = document.createElement("span");
                //element.className = "reefer-alert";
                //var imageElement = document.createElement("img");
                //imageElement.src = "../images/FuelFractionImages/" + image + ".png";
                //element.appendChild(imageElement);
                //return element;
                return <span className="reefer-alert"><img src={"../images/FuelFractionImages/" + image + ".png"}></img></span>;
            }

        }
    }
    static commandLogStatusFormatter(params) {
        if (params != null && params != undefined) {
            if (params.data.Status != null && params.data.Status != undefined && params.data.Status != '') {
                var imageElement = document.createElement("img");

                switch (params.data.Status.toString().toUpperCase().trim()) {

                    case "UNKNOWN":
                        return <span className="reefer-alert"><img src={UnknownStatus}></img></span>;
                    case "ERROR":
                        return <span className="reefer-alert"><img src={ErrorStatus}></img></span>;
                    case "PENDING":
                        return <span className="reefer-alert"><img src={PendingStatus}></img></span>;
                    case "ISSUED":
                        return <span className="reefer-alert"><img src={IssuedStatus}></img></span>;
                    case "EXPIRED":
                        return <span className="reefer-alert"><img src={ExpiredStatus}></img></span>;
                    case "CANCELLED":
                        return <span className="reefer-alert"><img src={CancelStatus}></img></span>;
                    case "SUCCESS":
                        return <span className="reefer-alert"><img src={SucessStatus}></img></span>;
                    case "COMMANDACCEPTEDBYRCD":
                        return <span className="reefer-alert"><img src={AcceptedStatus}></img></span>;
                    case "REJECTED":
                        return <span className="reefer-alert"><img src={RejectedStatus}></img></span>;
                    case "DISCARDED":
                        return <span className="reefer-alert"><img src={DiscardedStatus}></img></span>;
                    case "RETRY":
                        return <span className="reefer-alert"><img src={RetryStatus}></img></span>;
                    case "COMMANDACCEPTEDBYBUSYRCD":
                        return <span className="reefer-alert"><img src={AcceptedByBusyRCDStatus}></img></span>;
                    case "AWAITINGPREREQUISITES":
                        return <span className="reefer-alert"><img src={AwaitingPrerequisites}></img></span>;
                    case "CANCELLATIONREQUEST":
                        return <span className="reefer-alert"><img src={CancellationRequest}></img></span>;
                    case "AWAITINGSYNC":
                        return <span className="reefer-alert"><img src={PendingStatus}></img></span>;
                    case "SENTTOVC":
                        return <span className="reefer-alert"><img src={SendToVC}></img></span>;
                    case "SYNCERROR":
                        return <span className="reefer-alert"><img src={ErrorStatus}></img></span>;
                    case "SYNCCANCELLED":
                        return <span className="reefer-alert"><img src={CancelStatus}></img></span>;
                    case "VALIDATIONPENDING":
                        return <span className="reefer-alert"><img src={ValidationPendingStatus}></img></span>;
                    case "UNDELIVERABLE":
                        return <span className="reefer-alert"><img src={UndeliverableStatus}></img></span>;
                    default:
                        break;
                }
            }
            return <span className="reefer-alert"></span>;
        }

        return <span className="reefer-alert"></span>;
    }
    static gensetRunningFormatter(params) {
        if (params.data != null && params.data != undefined) {
            if (params.data.HasOilPressureSwitch != null && params.data.GensetRunning != null) {
                if (params.data.HasOilPressureSwitch.toString().toUpperCase().trim() == "TRUE") {
                    if (params.data.OEMTypeCD != null && params.data.OEMTypeCD.toString().toUpperCase().trim() == "C") {
                        return '';
                    }
                    else {
                        if (params.data.GensetRunning.toString().toUpperCase().trim() == "0" || params.data.GensetRunning.toString().toUpperCase().trim() == "FALSE")
                            return <span className="reefer-alert"><img src={NotRunning}></img></span>;
                        else if (params.data.GensetRunning.toString().toUpperCase().trim() == "1" || params.data.GensetRunning.toString().toUpperCase().trim() == "TRUE")
                            return <span className="reefer-alert"><img src={Running}></img></span>;
                        else
                            return '';
                    }
                }
                else
                    return '';
            }
            else
                return '';
        }
        else
            return '';
    }
    static stringTypeValueFormatter(params) {
        if (params.value != "-NA-" && params.value != "" && params.value != null) {//RCNG-1357
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }
    static floatTypeFormatter(params) {
        if (params.value != null && params.value != undefined) {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }
    static stringTypeFormatter(params) {

        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }

    static floatTypeValueFormatter(params) {
        if (params.value != "-NA-") {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }

    static GPSfloatTypeValueFormatter(params) {
        if (params.value != '-NA-') {
            return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }
    static GPSCoordsFormatter(params) {
        if (params.value != null && params.value != '-1000') {
            if (params.data != null && params.data != undefined && params.data != '') {
                if (params.data.DeviceType != null && params.data.DeviceType != undefined && (params.data.DeviceType.toString().toUpperCase().trim() == "GT1200" || params.data.DeviceType.toString().toUpperCase().trim() == "GT1020" || params.data.DeviceType.toString().toUpperCase().trim() == "GT1030")) {
                    if (params.value != null && params.value != '-1000')
                        return params.value;
                    else
                        return '-NA-';
                }
                else if (params.data.GPSLatitude != 0 && params.data.GPSLongitude != 0 && (params.data.GPSLockState == null || params.data.GPSLockState == '' || params.data.GPSLockState.toUpperCase() != "LOCKED")) {
                    if (params.value != null && params.value != '-1000') {
                        var pCss = {
                            'color': '#736F6E'
                        };
                        return <p style={pCss} ><i> {params.value}</i></p>;
                    }
                    else
                        return '-NA-';
                }
                else if (params.data.GPSCoords != null && params.data.GPSCoords != undefined && params.data.GPSCoords.toString().trim() == "") {
                    return '-NA-';
                }
                else
                    return params.value;
            }
        }
        else
            return '-NA-';
    }
    static stringTypeFormatterFor3P(params) {
        if (params.value != null && params.value != "null" && params.value != undefined && params.value != '' && params.value != '-NA-') {
            if (params.value === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName)
                return '-NA-';
            else
                return <span title={params.value}>{params.value}</span>;
        }
        else
            return '-NA-';
    }
    static CommentExistsFormatter(params) {

        if (params.value != null && params.value != undefined && params.value != '-NA-') {
            if (params.value == 0) {
                return <span className="Trip-edit"><img src={GroupChat}></img></span>;
            }
            else
                return "-NA-";
        }
        return "-NA-";
    }
    static GensetSwitchFormatterGrouping(param) {
        if (param != null && param != undefined) {
            if (param == "1")
                return <div><div className="poweronbgGrouping"><div className="fa fa-power-off power-icon"></div></div><div className="aggridOnOff"> ON</div></div>;
            else if (param == "0")
                return <div><div className="poweroffbgGrouping"><div className="fa fa-power-off power-icon"></div></div><div className="aggridOnOff"> OFF</div></div>;
            //else
            //    return "-NA-";
        }
        return "*No SW"
    }
    static removeIndicator(params: any) {
        return <span className="reefer-delete"><img src={deletepng} title='Remove' onClick={(e: any) => {
            params.api.gridOptionsWrapper.gridOptions.rowData.splice(params.rowIndex, 1);
            params.api.setRowData(params.api.gridOptionsWrapper.gridOptions.rowData);
        }}></img></span>;
    }

    static AssetStateFormatter(params) {
        if (params.data != null && params.data != undefined) {
            //var imageElement = document.createElement("img");
            var assetState = params.data.AssetState;
            if (params.data.AssetState != null && params.data.AssetState != undefined) {
                if (assetState.toUpperCase().trim() == 'A') {
                    return <span className="ActiveRA" title="Active"><img src={AssetStateActive}></img></span>;
                }
                else if (assetState.toUpperCase().trim() == 'D') {
                    return <span className="DisconnectedRA" title="Disconnected"><img src={AssetStateDisconnected}></img></span>;
                }
                else if (assetState.toUpperCase().trim() == 'R') {
                    return <span className="RetiredRA" title="Retired"><img src={AssetStateRetired}></img></span>;
                }
            }
        }
        return '-NA-';
    }
    static AssetStateFormatterGrouping(param) {
        if (param != null && param != undefined && param != '') {
            if (param == "A") {
                return <div><span className="ActiveRA"><img src={AssetStateActive} title="Active"></img></span><span className='aggrid-Inv pl-10'> Active</span></div>;
            }
            else if (param == "D") {
                return <div><span className="DisconnectedRA"><img src={AssetStateDisconnected} title="Disconnected"></img></span><span className='aggrid-Inv'> Disconnected</span></div>;
            }
            else if (param == "R") {
                return <div><span className="RetiredRA"><img src={AssetStateRetired} title="Retired"></img></span><span className='aggrid-Inv pl-10'> Retired</span></div>;
            }
        }
        return "*No INV";
    }
}
